import { formatToPKR } from "@/lib/helper";
import { OtherReport } from "@/types/pos/other-report";

interface OtherSummaryProps {
  data: any;
  isLoading: boolean;
}

export default function OtherSummary({ data, isLoading }: OtherSummaryProps) {
  if (isLoading) {
    return (
      <div className="space-y-3">
        <div className="grid gap-2 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4">
          <div className="animate-pulse bg-gray-100 rounded-md p-3 h-20"></div>
          <div className="animate-pulse bg-gray-100 rounded-md p-3 h-20"></div>
          <div className="animate-pulse bg-gray-100 rounded-md p-3 h-20"></div>
        </div>
      </div>
    );
  }

  // Read totals from summary API response
  const totalSales = data?.summary?.total_amount || 0;
  const totalTax = data?.summary?.total_tax_amount || 0;
  const subTotal = data?.summary?.total_sub_amount || 0;

  // Financial summary cards
  const financialCards = [
    {
      label: 'Total Sales',
      value: totalSales,
      color: 'green',
      icon: 'fa-chart-line'
    },
    {
      label: 'Total Sub',
      value: subTotal,
      color: 'indigo',
      icon: 'fa-percentage'
    },
    {
      label: 'Total Tax',
      value: totalTax,
      color: '',
      icon: 'fa-percentage'
    },
  ];

  const getColorClasses = (color: string) => {
    const colors = {
      green: 'bg-green-50 border-green-200 text-green-600',
      indigo: 'bg-indigo-50 border-indigo-200 text-indigo-600',
    };
    return colors[color as keyof typeof colors] || 'bg-gray-50 border-gray-200 text-gray-600';
  };

  return (
    <div className="space-y-3">
      <div className="grid gap-2 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4">
        {financialCards.map((card) => (
          <div
            key={card.label}
            className={`${getColorClasses(card.color)} border rounded-md p-2 sm:p-2.5`}
          >
            <div className="flex items-center justify-between mb-1">
              <p className="text-xs font-medium truncate pr-1">{card.label}</p>
              <i className={`fa-solid ${card.icon} text-xs flex-shrink-0`}></i>
            </div>
            <p className="text-base sm:text-lg font-bold leading-tight break-all">
              {formatToPKR(card.value)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
